import { Navigate, Route, Routes } from "react-router-dom";
import { lazy, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { AppLoader } from "../splash";
import VoteShutter from "../page/Vote/VoteShutter";
import Test from "../page/Vote/Test";
import TestStand from "../page/Vote/TestStand";
import VoteTest from "../page/Vote/VoteTest";
import SpinRobot from "../page/Vote/SpinRobot";
import { login } from "./../store/action/auth/index";
const Main = lazy(() => import("../page/Step/Main"));
const Vote = lazy(() => import("../page/Vote"));
const Setting = lazy(() => import("../page/Setting"));

export const Router = ({ mode, changeMode }) => {
  const dispatch = useDispatch();

  const fetchLogin = async ({ countryCode, mobile, password }) => {
    await login({
      mobile: countryCode + mobile,
      password,
    })(dispatch);
  };

  useEffect(() => {
    fetchLogin({
      countryCode: "20",
      mobile: "1099093619",
      password: "123456789",
    });
  }, []);

  // localStorage.setItem("token", process.env.REACT_APP_Token);

  return (
    <Routes>
      <Route path="/vote-screen" element={<Vote />} />
      <Route path="/vote-stand" element={<VoteShutter />} />
      <Route path="/test" element={<Test />} />
      <Route path="/test-stand" element={<TestStand />} />

      <Route path="/vote-test" element={<VoteTest />} />

      <Route path="/spin-robot" element={<SpinRobot />} />

      <Route path="/setting" element={<Setting />} />

      <Route path="/*" element={<Main />} />

      {/* <Route
        path="login"
        element={<SuspenseComponent>{<LoginPage />}</SuspenseComponent>}
      />
      <Route path="/*" element={<Main />} /> */}

      {/* <Route
        path="404"
        element={/* <NotFound /> 
      />
      <Route path="*" element={<Navigate to="/404" />} /> */}
    </Routes>
  );
};

export default Router;
